import { QueryKey, UseQueryOptions } from 'react-query';
import { Config, getConfig } from './api';
import { configKey } from './keys';
import { ChannelConcurrencyGroup } from './types';

export interface ConfigQueryOptions<T = Config> extends UseQueryOptions<Config, unknown, T, QueryKey> {}

export function configQuery<T = Config>(options?: ConfigQueryOptions<T>) {
  return { queryKey: configKey(), queryFn: () => getConfig(), ...options } as const;
}

export function channelConcurrencyGroupsQuery() {
  return configQuery({
    select: (config) => {
      const channelConcurrencyGroupItems = config.find(
        (customConfig) => customConfig.key === 'channelConcurrencyGroups_denmark',
      );

      if (channelConcurrencyGroupItems) {
        return JSON.parse(channelConcurrencyGroupItems.value) as ChannelConcurrencyGroup[];
      }

      return [] as ChannelConcurrencyGroup[];
    },
  });
}
